import { Card, Box } from '..'

const OfficeCard = ({ children, sx = {} }) => {
    return <Card sx={{ flex: 1, marginRight: 1, padding: 1, ...sx }}>
        <Box sx={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'column', flex: 1, height: '100%' }}>
            {children}
        </Box>
    </Card>
}

export default OfficeCard